import { render } from "./AddVirtualSkipperModal.vue?vue&type=template&id=4b9e02ce&scoped=true"
import script from "./AddVirtualSkipperModal.vue?vue&type=script&lang=js"
export * from "./AddVirtualSkipperModal.vue?vue&type=script&lang=js"

import "./AddVirtualSkipperModal.vue?vue&type=style&index=0&id=4b9e02ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9e02ce"]])

export default __exports__